import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditCloseDateComponent } from 'src/app/components/modals/add-edit-close-date/add-edit-close-date.component';
import { PartnerService } from '../../../../../services/partner.service';
import { HelpersService } from 'src/app/services';
import { TechnicianService } from 'src/app/services/technician.service';
import moment from 'moment';

@Component({
  selector: 'app-closing-dates',
  templateUrl: './closing-dates.component.html',
  styleUrls: ['./closing-dates.component.scss'],
})
export class ClosingDatesComponent implements OnInit {
  @Input() users;
  public closedDates = [];
  public days = [];
  technicianEvents: any = [];
  leaveEvent = false;
  public countryData: any = {};

  constructor(
    public modalService: NgbModal,
    public partnerService: PartnerService,
    private helpersService: HelpersService,
    public technicianService: TechnicianService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.getCloseDates();
  }

  getCloseDates() {
    var startDate = new Date();
    var endDate = new Date();
    startDate.setDate(startDate.getDate() - 1);
    endDate.setMonth(endDate.getMonth() + 12);
    const technician = this.users.filter((x) => x.TechnicianID);
    technician.forEach((tech) => {
      this.technicianService
        .getTechnicianEvents(
          tech.TechnicianID,
          startDate.toISOString(),
          endDate.toISOString(),
        )
        .subscribe((res) => this.filterEvents(res, tech.TechnicianID));
    });
  }

  filterEvents(events, technicianID) {
    this.days = [];
    const filteredEvents = events.filter((event) => {
      const startTime = new Date(event.StartTime);
      return (
        event.Description != 'leave' &&
        startTime.getHours() === 7 &&
        new Date(event.EndTime).getHours() === 22
      );
    });
    if (filteredEvents[0]) {
      this.closedDates = [];
      let currentEvent = filteredEvents[0].RecurrenceID;
      let startEventTime = filteredEvents[0].StartTime;
      filteredEvents.forEach((event, i) => {
        if (currentEvent !== event.RecurrenceID) {
          currentEvent = event.RecurrenceID;
          this.closedDates.push({
            ...filteredEvents[i - 1],
            StartTime: startEventTime,
          });
          this.days.push(
            moment(filteredEvents[i - 1].EndTime).diff(
              moment(startEventTime),
              'days',
            ),
          );
          startEventTime = event.StartTime;
        }
      });
      this.closedDates.push({
        ...filteredEvents[filteredEvents.length - 1],
        StartTime: startEventTime,
      });
      this.technicianEvents.push({ [technicianID]: this.closedDates });
      this.days.push(
        moment(filteredEvents[filteredEvents.length - 1].EndTime).diff(
          moment(startEventTime),
          'days',
        ),
      );
    }
  }

  addCloseDate() {
    const modalRef = this.modalService.open(AddEditCloseDateComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.users = this.users.filter((x) => x.TechnicianID);
    modalRef.result.then((result) => {
      this.getCloseDates();
    });
  }

  deleteEvent(event, i) {
    let count = 0;
    this.technicianEvents.forEach((closeDates) => {
      const ID = parseInt(Object.keys(closeDates)[0]);
      this.technicianService
        .cancelCalendarEvent(ID, closeDates[ID][i].ID, true)
        .subscribe((result) => {
          count++;
          if (count === this.technicianEvents.length) {
            this.technicianEvents = [];
            this.closedDates = [];
            this.getCloseDates();
          }
        });
    });
  }
}
